import { computed } from "vue";
import type { ProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { FilteredProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";

export function useProductPrices(
	product: (Partial<FilteredProductItem> | ProductItem) & { OldPrice?: string }
) {
	const oldPrice = computed(() => {
		if (product?.VatRate) {
			return product.PriceStandard! * product.VatRate;
		}

		if (product.OldPrice) {
			return product.OldPrice;
		}

		return null;
	});

	return {
		oldPrice
	};
}
